var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticStyle: { "padding-left": "20px", "padding-right": "20px" } },
        [
          _c(
            "Form",
            {
              ref: "productForm",
              attrs: { "label-position": "left", "label-width": 80 },
            },
            [
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "16" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "产品列表" } },
                        [
                          _c(
                            "Select",
                            {
                              attrs: {
                                transfer: "",
                                multiple: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.productSelectList,
                                callback: function ($$v) {
                                  _vm.productSelectList = $$v
                                },
                                expression: "productSelectList",
                              },
                            },
                            _vm._l(_vm.productList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.productUuid,
                                  attrs: { value: item.productUuid },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(item.productName) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "8" } },
                    [
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: { type: "success", shape: "circle" },
                          on: { click: _vm.selectAllProduct },
                        },
                        [_vm._v("全选")]
                      ),
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: { type: "warning", shape: "circle" },
                          on: { click: _vm.deleteSelectList },
                        },
                        [_vm._v("清空选项")]
                      ),
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: { type: "primary", shape: "circle" },
                          on: { click: _vm.AddProductsData },
                        },
                        [_vm._v("选项添加")]
                      ),
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: { type: "error", shape: "circle" },
                          on: { click: _vm.deleteProductsData },
                        },
                        [_vm._v("清空列表")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Card",
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("stand-pagination-table", {
                    ref: "mainTable",
                    attrs: {
                      columns: _vm.mainTable.tableColumns,
                      data: _vm.mainTable.tableData,
                      loading: _vm.mainTable.tableLoading,
                      "table-search": _vm.mainTable.tableSearch,
                      "table-load-event": _vm.getMainTableRecords,
                      showPage: false,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }